export default "\n<router-outlet></router-outlet>\n\n\n<div class=\"debug-info\" *ngIf=\"!production\">DEV</div>"